import React, { Component } from 'react';

class ComboTipoCuenta extends Component {
    
    render() {
        const { selectCombo, tipoCuenta, tipoCuentaSeleccionada } = this.props

        let firstOption = {Id:0,Descripcion: "Todos" }    
        let esPrepaga = tipoCuenta && tipoCuenta.length > 0 ? tipoCuenta.filter(x => x.Descripcion.toString().toLowerCase() == "prepaga") : undefined;
        let valor = esPrepaga && esPrepaga.length > 0 ? esPrepaga[0].Id : "";    
        valor = tipoCuentaSeleccionada ? tipoCuentaSeleccionada : valor;
 
        return (
            <div>
                <select id="-1" value={valor} name="tipoCuenta" className="form-control default-select confirmadorAjusteCargoSeccionSuperiorSelect" onChange={(event) => {
                    const index = event.target.selectedIndex;
                    const value = event.target.options[index].value;
                    selectCombo("tipoCuentaSeleccionada", value) 
                }}>
                    <option  key={firstOption.Id} value={firstOption.Id}>{firstOption.Descripcion}</option> 
                    {tipoCuenta && tipoCuenta.length > 0 && tipoCuenta.map( (item,index) => {return <option style={{color:"black"}} key={index} value={item.Id}>{item.Descripcion}</option>} )}
                </select>
            </div>
        );
    }
}

export default ComboTipoCuenta;